/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_No_Media_ErrorInputs */

const en_ocr_no_media_error = /** @type {(inputs: Ocr_No_Media_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No media file loaded`)
};

const fr_ocr_no_media_error = /** @type {(inputs: Ocr_No_Media_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun fichier multimédia chargé`)
};

const de_ocr_no_media_error = /** @type {(inputs: Ocr_No_Media_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Mediendatei geladen`)
};

const it_ocr_no_media_error = /** @type {(inputs: Ocr_No_Media_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun file multimediale caricato`)
};

const ru_ocr_no_media_error = /** @type {(inputs: Ocr_No_Media_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Медиафайл не загружен`)
};

const es_ocr_no_media_error = /** @type {(inputs: Ocr_No_Media_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha cargado ningún archivo multimedia.`)
};

const zh_cn2_ocr_no_media_error = /** @type {(inputs: Ocr_No_Media_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未加载媒体文件`)
};

const ja_ocr_no_media_error = /** @type {(inputs: Ocr_No_Media_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアファイルが読み込まれませんでした`)
};

const hi_ocr_no_media_error = /** @type {(inputs: Ocr_No_Media_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई मीडिया फ़ाइल लोड नहीं हुई`)
};

const pt_pt2_ocr_no_media_error = /** @type {(inputs: Ocr_No_Media_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum arquivo de mídia carregado`)
};

/**
* | output |
* | --- |
* | "No media file loaded" |
*
* @param {Ocr_No_Media_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_no_media_error = /** @type {((inputs?: Ocr_No_Media_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_No_Media_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_no_media_error(inputs)
	if (locale === "de") return de_ocr_no_media_error(inputs)
	if (locale === "it") return it_ocr_no_media_error(inputs)
	if (locale === "ru") return ru_ocr_no_media_error(inputs)
	if (locale === "es") return es_ocr_no_media_error(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_no_media_error(inputs)
	if (locale === "ja") return ja_ocr_no_media_error(inputs)
	if (locale === "hi") return hi_ocr_no_media_error(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_no_media_error(inputs)
	return en_ocr_no_media_error(inputs)
});